import { businessHeadJobQueueService } from './business-head/BusinessHeadJobQueueService';
import { columnFilterStore } from './ColumnFilterStore';
import { viewJobServiceStore } from './job/ViewJobServiceStore';
import { managementJobQueueService } from './management/ManagementJobQueueService';
import { managementTeamsService } from './management/ManagementTeamsService';
import { managementStore } from './ManagementStore';
import { managerJobQueueService } from './manager/ManagerJobQueueService';
import { profileStore } from './ProfileStore';
import { recruiterJobQueueService } from './recruiter/RecruiterJobQueueService';
import { supportJobQueueService } from './support/SupportJobQueueService';
import { teamLeadJobQueueService } from './team-lead/TeamLeadJobQueueService';

export class RootStore {
  managementStore = managementStore;
  managementTeamsService = managementTeamsService;
  managementJobQueueService = managementJobQueueService;
  profileStore = profileStore;
  viewJobServiceStore = viewJobServiceStore;
  businessHeadJobQueueService = businessHeadJobQueueService;
  managerJobQueueService = managerJobQueueService;
  recruiterJobQueueService = recruiterJobQueueService;
  supportJobQueueService = supportJobQueueService;
  teamLeadJobQueueService = teamLeadJobQueueService;
  columnFilterStore = columnFilterStore;

  constructor() {
    // Add more stores here as needed
  }

  initAllStores() {
    // Global initialization logic if needed
  }

  resetAllStores() {
    this.managementStore.reset();
    this.managementTeamsService.reset();
    this.managementJobQueueService.reset();
    this.profileStore.reset();
    this.viewJobServiceStore.clearJobInfo();
    this.businessHeadJobQueueService.reset();
    this.managerJobQueueService.reset();
    this.recruiterJobQueueService.reset();
    this.supportJobQueueService.reset();
    this.teamLeadJobQueueService.reset();
    this.columnFilterStore.reset();
  }
}

export const rootStore = new RootStore();
